export var JobTitleEnum;
(function (JobTitleEnum) {
    JobTitleEnum["ENGINEER"] = "engineer";
    JobTitleEnum["ENGINEERING_MANAGER"] = "engineering_manager";
    JobTitleEnum["ARCHITECT"] = "architect";
    JobTitleEnum["PRODUCT_MANAGER"] = "product_manager";
    JobTitleEnum["DESIGNER"] = "designer";
    JobTitleEnum["FOUNDER"] = "cxo_founder";
    JobTitleEnum["MARKETING_MANAGER"] = "marketing_manager";
    JobTitleEnum["STUDENT"] = "student";
    JobTitleEnum["CXO"] = "cxo";
    JobTitleEnum["OTHER"] = "other";
})(JobTitleEnum || (JobTitleEnum = {}));
export var OrganizationTypeEnum;
(function (OrganizationTypeEnum) {
    OrganizationTypeEnum["COMPANY"] = "Company";
    OrganizationTypeEnum["AGENCY"] = "Agency";
    OrganizationTypeEnum["EDUCATIONAL"] = "Student";
    OrganizationTypeEnum["SOLOPRENEUR"] = "Solopreneur";
    OrganizationTypeEnum["OTHER"] = "Other";
})(OrganizationTypeEnum || (OrganizationTypeEnum = {}));
export var CompanySizeEnum;
(function (CompanySizeEnum) {
    CompanySizeEnum["LESS_THAN_10"] = "<10";
    CompanySizeEnum["BETWEEN_10_50"] = "10-50";
    CompanySizeEnum["BETWEEN_51_100"] = "51-100";
    CompanySizeEnum["MORE_THAN_100"] = "100+";
})(CompanySizeEnum || (CompanySizeEnum = {}));
export const jobTitleToLabelMapper = {
    [JobTitleEnum.ENGINEER]: 'Engineer',
    [JobTitleEnum.ARCHITECT]: 'Architect',
    [JobTitleEnum.PRODUCT_MANAGER]: 'Product Manager',
    [JobTitleEnum.DESIGNER]: 'Designer',
    [JobTitleEnum.ENGINEERING_MANAGER]: 'Engineering Manager',
    [JobTitleEnum.FOUNDER]: 'Founder',
    [JobTitleEnum.STUDENT]: 'Student',
    [JobTitleEnum.CXO]: 'CXO (CTO/CEO/other...)',
    [JobTitleEnum.MARKETING_MANAGER]: 'Marketing Manager',
    [JobTitleEnum.OTHER]: 'Other',
};
export var NewDashboardOptInStatusEnum;
(function (NewDashboardOptInStatusEnum) {
    NewDashboardOptInStatusEnum["OPTED_IN"] = "opted_in";
    NewDashboardOptInStatusEnum["DISMISSED"] = "dismissed";
    NewDashboardOptInStatusEnum["OPTED_OUT"] = "opted_out";
    // undefined -> user has not interacted with the widget yet
})(NewDashboardOptInStatusEnum || (NewDashboardOptInStatusEnum = {}));
//# sourceMappingURL=user.js.map